import { render, staticRenderFns } from "./NeuroscienceEvaluationScores.vue?vue&type=template&id=2cb14a13&"
import script from "./NeuroscienceEvaluationScores.vue?vue&type=script&lang=ts&"
export * from "./NeuroscienceEvaluationScores.vue?vue&type=script&lang=ts&"
import style0 from "./NeuroscienceEvaluationScores.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports